import React, { useEffect, useState } from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__timeSynchronization.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { InputField } from '../../../blocks.simple/InputField/InputField'
import { WikiInfo } from '../../../blocks.simple/wikiInfo/WikiInfo'

type TimeSynchronization = {
    enabled: boolean
    discrepancy: number
    requestFrequency: number
}

const TimeSynchronization = (p_: {
    enabled: boolean
    data: TimeSynchronization
    onChange: (value: any, field: string) => void
}) => {
    const [data, setData] = useState<TimeSynchronization | null>(p_.data)

    const onChangeData = (value: string | boolean, field: string) => {
        if (!data) return

        const newData = {
            ...data,
            [field]: value,
        }

        setData(newData)
    }

    useEffect(() => {
        if (JSON.stringify(p_.data) !== JSON.stringify(data)) {
            setData(p_.data)
        }
    }, [p_.data])

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!data) return

            if (JSON.stringify(p_.data) !== JSON.stringify(data)) {
                const newData = {
                    enabled: data.enabled,
                    discrepancy: +data.discrepancy,
                    requestFrequency: +data.requestFrequency,
                }

                if (newData.discrepancy < 5) {
                    newData.discrepancy = 5
                }
                if (newData.discrepancy > 300) {
                    newData.discrepancy = 300
                }
                if (newData.requestFrequency < 15) {
                    newData.requestFrequency = 15
                }
                if (newData.requestFrequency > 1440) {
                    newData.requestFrequency = 1440
                }

                p_.onChange(newData, 'timeSynchronization')

                setData(newData)
            }
        }, 500)

        return () => clearTimeout(timeout)
    }, [data])

    return data ? (
        <div className={styles.content}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={data.enabled}
                    onChange={() => {
                        onChangeData(!data.enabled, 'enabled')
                    }}
                    className={`test-settings-toggle_${data.enabled ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <span>{translate('accurateTimeSync')}</span>
                    <WikiInfo blockKey={'settings'} blockSubKey={'automatization'} infoKey={'timeSynchronization'} />
                </div>
            </div>
            {data.enabled && (
                <>
                    <div className={styles.field}>
                        <InputField
                            type={'number'}
                            label={translate('timeDiscrepancy')}
                            value={data.discrepancy}
                            onChange={(value: string) => {
                                onChangeData(value, 'discrepancy')
                            }}
                            tooltipText={translate('timeDiscrepancyBetween')}
                        />
                    </div>
                    <div className={styles.field}>
                        <InputField
                            type={'number'}
                            label={translate('requestFrequency')}
                            value={data.requestFrequency}
                            onChange={(value: string) => {
                                onChangeData(value, 'requestFrequency')
                            }}
                            tooltipText={translate('requestFrequencyTooltip')}
                        />
                    </div>
                </>
            )}
        </div>
    ) : null
}

export default React.memo(TimeSynchronization)
